import styled from 'styled-components';

import {Link} from 'components/ui-kit/Link';

export const Container = styled.div`
    height: calc(100vh - 106px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
        margin-bottom: 20px;
    }
`;

export const CustomLink = styled(Link)`
    font-size: 20px;
`;
